import { multiOffersService } from '@/infrastructure/Factory'
import cloneDeep from 'lodash/cloneDeep'

export default {
  async getLocation({ commit }) {
    const { allDestinations, offer, hotels } = await multiOffersService.getInitialMultiOffer()

    const { filterToApply, datesFromUrl } = multiOffersService.getFiltersFromUrl(offer)

    commit('updateAllDestinations', allDestinations)
    commit('hotels', hotels)
    commit('updateOffer', offer)
    commit('updatedatesFromLanding', datesFromUrl)
    commit('updateFilterApply', filterToApply)
  },

  async getPrices({ commit, state }) {
    const allHotels = multiOffersService.getAllHotels(state.allDestinations)

    const prices = await multiOffersService.getPrices(
      allHotels,
      state.datesFromLanding.startDate,
      state.datesFromLanding.endDate,
      state.offer?.pacCode,
      state.offer?.corporateId
    )

    const allHotelsWithPrices = multiOffersService.addPricesToHotels(state.allDestinations, prices)
    // sort hotels ny minimum amount
    const cloneAllHotelsWithPrices = cloneDeep(allHotelsWithPrices)
    cloneAllHotelsWithPrices.forEach(country =>
      country.cities.forEach(city => {
        const zeros = city.hotels.filter(hotel => hotel?.priceFrom?.amount === 0)
        const nonZeros = city.hotels.filter(hotel => hotel?.priceFrom?.amount !== 0)
        const sorted = nonZeros.sort((a, b) => (a?.priceFrom?.amount > b?.priceFrom?.amount ? 1 : -1))
        city.hotels = sorted.concat(zeros)
      })
    )

    const allDestinationsWithPrices = multiOffersService.addPricesToCities(
      cloneAllHotelsWithPrices,
      prices
    )
    commit('prices', prices)
    commit('updateAllDestinations', allDestinationsWithPrices)
  },

  async selectLocation({ dispatch }, location) {
    dispatch('trackOfferFilterApplied', {
      offerFilterType: 'location',
      offerFilterLocation: location.name
    })
  },

  async trackLoadMoreOffers() {
    global.trackingService.track(global.trackingEvents.LOAD_MORE_OFFERS)
  },

  async trackOfferFilterApplied({ getters }, eventData) {
    global.trackingService.track(
      global.trackingService.eventBuilder(global.trackingEvents.OFFER_FILTER_APPLIED, eventData)
    )
  }
}
